import { useEffect } from "react"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePutAccont = (nameRef, nicknameRef) => {

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    const clickEvent = () => {
        fetchRequest("PUT", "/account", {
            "name": nameRef?.current?.value,
            "nickname": nicknameRef?.current?.value
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                window.location.reload()
                break
            case 400:
                if (fetchResult?.data?.error_code === "name") setAlert("이름 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "nickname") setAlert("닉네임 입력 양식을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("계정 데이터가 존재하지 않습니다.")
                break
            case 409:
                if (fetchResult?.data?.error_code === "nickname") setAlert("이미 존재하는 닉네임 입니다.")
                break
        }
    }, [fetchResult])

    return [clickEvent]
}

export default usePutAccont